/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Sativa = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Sativa"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#0E0E0E"
        d="M18 20v2H6v-2zm2-2V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2v2l-.206-.005a4 4 0 0 1-3.79-3.789L2 18V6a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v12a4 4 0 0 1-3.794 3.995L18 22v-2a2 2 0 0 0 2-2"
      />
      <path
        fill="#0E0E0E"
        d="M12.023 17.18q-.99 0-1.92-.375a5 5 0 0 1-1.62-1.065l1.02-1.185q.525.495 1.2.81.675.3 1.35.3.84 0 1.275-.345t.435-.915q0-.615-.435-.885a7.6 7.6 0 0 0-1.08-.555l-1.35-.585q-.48-.21-.945-.54-.45-.33-.75-.84-.285-.51-.285-1.23 0-.78.42-1.395.435-.63 1.17-.99.75-.375 1.71-.375.855 0 1.65.345.795.33 1.365.9l-.885 1.11q-.465-.39-.99-.615-.51-.225-1.14-.225-.69 0-1.125.315-.42.3-.42.84 0 .375.21.63.225.24.585.42.36.165.765.33l1.335.555q.87.375 1.425.99.555.6.555 1.665 0 .795-.42 1.455t-1.215 1.065q-.78.39-1.89.39"
      />
    </g>
  </svg>
);

export const SativaIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'sativa-icon'}
      icon={Sativa}
      {...props}
      size={size}
    />
  );
};
